import { useEffect } from "react";
import Bugsnag from "@lib/bugsnag";
import { useCurrentUser } from "@hooks/use-current-user";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import ClosetLayout from "./ClosetLayout/ClosetLayout";
import ClosetUnlockEarly from "./ClosetUnlockEarly";
import closetStates from "@utils/constants/closetStates";

function CurrentCloset() {
  const user = useCurrentUser();
  const customizableCloset = useCustomizableCloset();

  useEffect(() => {
    if (user?.id && customizableCloset?.id && customizableCloset?.state === "empty") {
      Bugsnag.notify(new Error("Current closet state is empty"), (event) => {
        // eslint-disable-next-line no-param-reassign
        event.context = "CurrentClosetEmpty";
        // eslint-disable-next-line no-param-reassign
        event.severity = "info";
        event.setUser(user);
        event.addMetadata("params", {
          closetId: customizableCloset?.id,
          closetState: customizableCloset?.state,
        });
      });
    }
  }, []);

  if (!customizableCloset?.id || customizableCloset?.state === closetStates.readyToChange)
    return null;

  return (
    <>
      <ClosetUnlockEarly />

      <ClosetLayout closet={customizableCloset} />
    </>
  );
}

export default CurrentCloset;
